import React from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { useTranslation } from '@lyearn/i18n';
import { TypographyWithTooltip } from '@lyearn/molecules';
import { Stack, StatusPill } from '@lyearn/ui';
import { useBaseCard } from '@/modules/content/components/ContentCard/BaseCard/Provider';
import { BaseCardComposition } from '@/modules/content/components/ContentCard/BaseCard/types';

const Name: BaseCardComposition['Name'] = (props) => {
  const { name, isOptionalContent } = useBaseCard();
  const { isMobile } = useScreen();
  const { variant = isMobile ? 'heading-xxs' : 'heading-xs', ...rest } = props;
  const { t } = useTranslation(['Common']);
  if (!name) {
    return null;
  }

  return (
    <Stack alignItems="center" gapX={8}>
      <TypographyWithTooltip variant={variant} {...rest}>
        {name}
      </TypographyWithTooltip>
      {isOptionalContent && !isMobile ? (
        <StatusPill
          appearance="secondary"
          label={t('Common:Optional')}
          size="medium"
          variant="light"
        />
      ) : null}
    </Stack>
  );
};

export default Name;
